export const root = state => state.get('terms');
export const terms = state => root(state).get('entities');
export const termById = (state, id) => terms(state).get(String(id));
export const termsByIds = (state, ids) => ids.map(id => termById(state, id));
